/**
 * Our legacy image stack has different urls than our cloudinary images,
 * these are found within our franchise pages (mic, ibd, and mcp)
 *
 * @param {string} imgSrc - legacy url for multisite files
 * @param {number} [width=387] width - width value
 * @param {number} [height=218] height - height value
 * @return {string} formatted image url
 *
 * @example
 * processAssetServer('multisite_files/fastcompany/REPLACE_ME/mic/mic-2016-logo.png')
 * // https://assets.fastcompany.com/multisite_files/fastcompany/imagecache/w/387/h/218/crop/mic/mic-2016-logo.png
 */
export default function processAssetServerImage(
  imgSrc,
  width = 387,
  height = 218
) {
  if (typeof imgSrc !== 'string') {
    return '';
  }

  return `https://assets.fastcompany.com/${imgSrc.replace(
    'REPLACE_ME',
    `imagecache/w/${width}/h/${height}/crop`
  )}`;
}



// WEBPACK FOOTER //
// ./src/utils/legacy_image_asset_util.js